"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAscii = void 0;
function isAscii(value) {
    if (!value)
        return true;
    return /^[\x00-\x7F]*$/.test(value);
}
exports.isAscii = isAscii;
//# sourceMappingURL=isAscii.js.map